import { render, staticRenderFns } from "./molixLaunchList.vue?vue&type=template&id=53bd5f28&scoped=true"
import script from "./molixLaunchList.vue?vue&type=script&lang=ts"
export * from "./molixLaunchList.vue?vue&type=script&lang=ts"
import style0 from "./molixLaunchList.vue?vue&type=style&index=0&id=53bd5f28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd5f28",
  null
  
)

export default component.exports